import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const KATEGORILER = {
  rezervasyon: { label: 'Rezervasyon', renk: 'blue',    bg: 'bg-blue-100',   text: 'text-blue-600',   dot: 'bg-blue-500'   },
  sms:         { label: 'SMS',         renk: 'amber',   bg: 'bg-amber-100',  text: 'text-amber-600',  dot: 'bg-amber-500'  },
  kasa:        { label: 'Kasa',        renk: 'emerald', bg: 'bg-emerald-100',text: 'text-emerald-600',dot: 'bg-emerald-500'},
  sistem:      { label: 'Sistem',      renk: 'slate',   bg: 'bg-slate-100',  text: 'text-slate-600',  dot: 'bg-slate-400'  },
};

const MOCK_BILDIRIMLAR = [
  { id: 1,  okundu: false, kategori: 'rezervasyon', ikon: '📥', baslik: 'Yeni rezervasyon',         icerik: 'Expedia kanalından Ahmet Yılmaz adına 101 nolu oda için rezervasyon alındı.',         tarih: '11.03.2026', saat: '16:42', path: '/rezervasyon' },
  { id: 2,  okundu: false, kategori: 'sms',         ikon: '⚠️', baslik: 'SMS gönderim başarısız',   icerik: '+90 532 xxx xx xx numarasına gönderim başarısız. Bakiye yetersiz olabilir.',           tarih: '11.03.2026', saat: '16:19', path: '/sms/ayarlar' },
  { id: 3,  okundu: true,  kategori: 'rezervasyon', ikon: '📥', baslik: 'Yeni rezervasyon',         icerik: 'Booking.com kanalından Fatma Kaya adına 205 nolu oda için rezervasyon alındı.',       tarih: '11.03.2026', saat: '15:05', path: '/rezervasyon' },
  { id: 4,  okundu: true,  kategori: 'sistem',      ikon: '🔔', baslik: 'Check-out hatırlatıcı',    icerik: 'Mehmet Demir — 302 nolu oda bugün check-out. Saat: 12:00',                            tarih: '11.03.2026', saat: '09:00', path: '/rezervasyon' },
  { id: 5,  okundu: true,  kategori: 'rezervasyon', ikon: '📥', baslik: 'Yeni rezervasyon',         icerik: 'Website kanalından Ali Çelik adına 101 nolu oda için rezervasyon alındı.',            tarih: '10.03.2026', saat: '22:34', path: '/rezervasyon' },
  { id: 6,  okundu: true,  kategori: 'kasa',        ikon: '💰', baslik: 'Günlük kasa kapatıldı',    icerik: 'Dün günlük kasa başarıyla kapatıldı. Toplam gelir: 12.400 TL',                       tarih: '10.03.2026', saat: '23:59', path: '/kasa/gunluk' },
  { id: 7,  okundu: true,  kategori: 'rezervasyon', ikon: '❌', baslik: 'Rezervasyon iptal',        icerik: 'Booking.com kanalından Zeynep Arslan rezervasyonu iptal edildi. Oda: 204',            tarih: '10.03.2026', saat: '18:11', path: '/rezervasyon' },
  { id: 8,  okundu: true,  kategori: 'sms',         ikon: '✅', baslik: 'SMS gönderim başarılı',    icerik: 'Check-in hatırlatma SMS\'i 8 misafire başarıyla gönderildi.',                         tarih: '10.03.2026', saat: '10:00', path: '/sms/gonder' },
  { id: 9,  okundu: true,  kategori: 'sistem',      ikon: '🔔', baslik: 'Check-in hatırlatıcı',     icerik: '3 misafirin bugün check-in\'i var. Oda hazırlıkları tamamlandı mı?',                  tarih: '10.03.2026', saat: '08:00', path: '/rezervasyon' },
  { id: 10, okundu: true,  kategori: 'kasa',        ikon: '💳', baslik: 'Taksit ödeme hatırlatıcı', icerik: 'Ali Çelik — 2.500 TL taksit ödemesi bu hafta son. Son tarih: 15.03.2026',            tarih: '09.03.2026', saat: '09:00', path: '/kasa/taksit-odemeler' },
];

export default function Bildirimler() {
  const navigate = useNavigate();
  const [filtre, setFiltre]       = useState('tumu');
  const [kategori, setKategori]   = useState('tumu');
  const [bildirimler, setBildirimler] = useState(MOCK_BILDIRIMLAR);

  const okunmamisSayi = bildirimler.filter(b => !b.okundu).length;

  const filtrelenmis = bildirimler.filter(b => {
    if (filtre === 'okunmamis' && b.okundu) return false;
    if (kategori !== 'tumu' && b.kategori !== kategori) return false;
    return true;
  });

  const tumunuOku = () => setBildirimler(prev => prev.map(b => ({ ...b, okundu: true })));
  const okunduIsaretle = (id) => setBildirimler(prev => prev.map(b => b.id === id ? { ...b, okundu: true } : b));
  const sil = (id) => setBildirimler(prev => prev.filter(b => b.id !== id));

  // Tarihe göre grupla
  const gruplar = filtrelenmis.reduce((acc, b) => {
    if (!acc[b.tarih]) acc[b.tarih] = [];
    acc[b.tarih].push(b);
    return acc;
  }, {});

  const tarihEtiket = (tarih) => {
    const bugun = new Date().toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\./g, '.');
    const dun = new Date(Date.now() - 86400000).toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\./g, '.');
    if (tarih === bugun) return 'Bugün';
    if (tarih === dun)   return 'Dün';
    return tarih;
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">

      {/* Başlık */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-xl font-bold text-gray-900">Bildirimler</h1>
          <p className="text-sm text-gray-500 mt-0.5">
            {okunmamisSayi > 0 ? `${okunmamisSayi} okunmamış bildirim` : 'Tüm bildirimler okundu'}
          </p>
        </div>
        {okunmamisSayi > 0 && (
          <button onClick={tumunuOku}
            className="text-sm text-blue-600 hover:text-blue-800 font-medium bg-blue-50 hover:bg-blue-100 px-4 py-2 rounded-lg transition-colors">
            Tümünü okundu say
          </button>
        )}
      </div>

      {/* Filtreler */}
      <div className="flex flex-wrap items-center gap-3 mb-6">
        {/* Okundu filtresi */}
        <div className="flex gap-1 bg-gray-100 p-0.5 rounded-xl">
          {[['tumu', 'Tümü'], ['okunmamis', 'Okunmamış']].map(([val, label]) => (
            <button key={val} onClick={() => setFiltre(val)}
              className={`px-3.5 py-1.5 text-sm rounded-lg font-medium transition-all
                ${filtre === val ? 'bg-white text-gray-800 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}>
              {label}
              {val === 'okunmamis' && okunmamisSayi > 0 && (
                <span className="ml-1.5 bg-red-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full">{okunmamisSayi}</span>
              )}
            </button>
          ))}
        </div>

        {/* Kategori filtresi */}
        <div className="flex gap-1.5 flex-wrap">
          <button onClick={() => setKategori('tumu')}
            className={`px-3 py-1.5 text-xs rounded-lg font-medium border transition-all
              ${kategori === 'tumu' ? 'bg-indigo-600 text-white border-indigo-600' : 'text-gray-500 border-gray-200 hover:border-gray-400 hover:text-gray-700'}`}>
            Tümü
          </button>
          {Object.entries(KATEGORILER).map(([key, kat]) => (
            <button key={key} onClick={() => setKategori(key)}
              className={`px-3 py-1.5 text-xs rounded-lg font-medium border transition-all
                ${kategori === key
                  ? `${kat.bg} ${kat.text} border-transparent`
                  : 'text-gray-500 border-gray-200 hover:border-gray-400 hover:text-gray-700'}`}>
              {kat.label}
            </button>
          ))}
        </div>
      </div>

      {/* Bildirim listesi */}
      {Object.keys(gruplar).length === 0 ? (
        <div className="text-center py-16 text-gray-400">
          <div className="text-4xl mb-3">🔔</div>
          <p className="text-sm font-medium">Bildirim bulunamadı</p>
          <p className="text-xs mt-1">Seçili filtreye uygun bildirim yok</p>
        </div>
      ) : (
        <div className="space-y-6">
          {Object.entries(gruplar).map(([tarih, items]) => (
            <div key={tarih}>
              {/* Tarih başlığı */}
              <div className="flex items-center gap-3 mb-3">
                <span className="text-xs font-bold text-gray-400 uppercase tracking-widest">{tarihEtiket(tarih)}</span>
                <div className="flex-1 h-px bg-gray-100" />
              </div>

              {/* Bildirimler */}
              <div className="space-y-2">
                {items.map(b => {
                  const kat = KATEGORILER[b.kategori];
                  return (
                    <div key={b.id}
                      className={`group flex items-start gap-3 p-4 rounded-2xl border transition-all cursor-pointer
                        ${!b.okundu
                          ? 'bg-blue-50/60 border-blue-100 hover:bg-blue-50'
                          : 'bg-white border-gray-100 hover:border-gray-200 hover:bg-gray-50'}`}
                      onClick={() => { okunduIsaretle(b.id); navigate(b.path); }}>

                      {/* İkon */}
                      <div className={`w-10 h-10 rounded-xl flex items-center justify-center text-lg flex-shrink-0 ${kat.bg}`}>
                        {b.ikon}
                      </div>

                      {/* İçerik */}
                      <div className="flex-1 min-w-0">
                        <div className="flex items-start justify-between gap-2">
                          <div className="flex items-center gap-2 flex-wrap">
                            <p className={`text-sm font-semibold leading-tight ${!b.okundu ? 'text-gray-900' : 'text-gray-700'}`}>
                              {b.baslik}
                            </p>
                            <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full ${kat.bg} ${kat.text}`}>
                              {kat.label}
                            </span>
                          </div>
                          <div className="flex items-center gap-2 flex-shrink-0">
                            {!b.okundu && <span className={`w-2 h-2 rounded-full flex-shrink-0 ${kat.dot}`} />}
                            <span className="text-[11px] text-gray-400 whitespace-nowrap">{b.saat}</span>
                          </div>
                        </div>
                        <p className="text-xs text-gray-500 mt-1 leading-relaxed">{b.icerik}</p>
                      </div>

                      {/* Sil butonu — hover'da görünür */}
                      <button
                        onClick={e => { e.stopPropagation(); sil(b.id); }}
                        className="opacity-0 group-hover:opacity-100 flex-shrink-0 w-6 h-6 rounded-lg flex items-center justify-center text-gray-400 hover:text-red-500 hover:bg-red-50 transition-all text-xs mt-0.5">
                        ✕
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}